import { lazy } from 'react';
import retry from '../../utils/webpack/chunkRetry';
const ModuleLoaderLazy = lazy(()=>retry(()=>import(/* webpackChunkName: "groups" */ './ModuleLoader')));
export default ModuleLoaderLazy;
